import { simpleFetch } from './customFetch';

export const getCouponContent = (coupon, screenKey) => simpleFetch(
  `/coupon-contents?screenKey=${screenKey}&couponCode=${coupon}`, {}, process.env.REACT_APP_REDEEM_API,
);
